export var config = {
  background: '#23262E',
  foreground: '#D5CED9',
  selection: '#db45a280',
  selectionMatch: '#db45a280',
  cursor: '#FFF',
  dropdownBackground: '#2b303b',
  dropdownBorder: '#363c49',
  activeLine: '#596a992e',
  matchingBracket: '#746f77',
  keyword: '#c74ded',
  storage: '#c74ded',
  variable: '#00e8c6',
  parameter: '#00e8c6',
  function: '#FFE66D',
  string: '#96E072',
  constant: '#ee5d43',
  type: '#FFE66D',
  class: '#FFE66D',
  number: '#ee5d43',
  comment: '#A0A1A7cc',
  heading: '#ff00aa',
  invalid: null,
  regexp: '#96E072',
  tag: '#f92672'
};